import ks from "../ReUsableTS/kalmstromShared4";
import { kDiv,khtmlButton} from "../ReUsableTS/kHTML";
import LNG from "./kLNG";
import { kStyleClass, kStyles } from "./kStyles";
export class kModalDialog{
    public DestroyOnClose:boolean = false;
    public isOpen = false;
    public DialogContainer: HTMLDivElement = document.createElement("div");
    public DialogContent: HTMLDivElement = document.createElement("div");
    public InnerContent: HTMLDivElement = document.createElement("div");
    public Height: number = 0;
    public Width: number = 0;
    public Top:number = -1; //Centered

    public Title: string = "";
    public TitleDiv: HTMLDivElement = document.createElement("div");

    public showCancelButton: boolean = false;
    public CancelButtonTopRight: HTMLSpanElement = document.createElement("span");
    public OnCancelCB: any = null;
    public CancelButton:khtmlButton = new khtmlButton();
    public CancelButtonCaption:string = "";

    public showOKButton: boolean = false;
    public OKButton: khtmlButton= new khtmlButton();;
    public OKButtonCaption:string = "";
    public OKCB: any = null;
    private _ButtonRow: HTMLDivElement | null = null;

    public ContentHTML: string = "";
    private _KeyHandler: ((ev: KeyboardEvent) => void) | null = null;
    private _PreviouslyFocused: HTMLElement | null = null;
    private _FocusTrapHandler: ((ev: KeyboardEvent) => void) | null = null;

    constructor (Title?: string, ContentHTML?: string, onCancelCB?: any, Height?: number, Width?: number, showCancelButton?: boolean,OKButtonFirst?:boolean){
        if (ks.kErrorMode === true) { return; }
        try {
            if(undefined !== Title){
                this.Title = ks.nz(Title);
            }
            if(undefined !== ContentHTML){
                this.ContentHTML = ks.nz(ContentHTML);
            }
            if(undefined !== Height){
                this.Height = ks.n0(Height);
            }
            if(undefined !== Width){
                this.Width = ks.n0(Width);
            }
            if(showCancelButton !== undefined){
                this.showCancelButton = ks.nb(showCancelButton);
            }
            if (undefined !== onCancelCB) {
                this.OnCancelCB = onCancelCB;
            }

            this.DialogContainer = new kDiv().Div;
            this.DialogContainer.classList.add("kDialogContainer");
            if(this.DialogContainer===null){return;}
            let CurrStyle: CSSStyleDeclaration = this.DialogContainer.style;
            
            CurrStyle.display ="none"; /* Hidden by default */
            CurrStyle.position ="fixed"; /* Stay in place */
            CurrStyle.zIndex = "99999"; /* Sit on top */
            CurrStyle.left =  "0px";
            CurrStyle.top =  "0px";
            CurrStyle.width = "100%"; /* Full width */
            CurrStyle.height ="100%"; /* Full height */
            CurrStyle.overflow = "hidden"; /* No scrollbar on overlay */
            CurrStyle.backgroundColor = "rgb(0,0,0)"; /* Fallback color */
            CurrStyle.backgroundColor = "rgba(0,0,0,0.4)"; /* Black w/ opacity */
            CurrStyle.fontFamily = "Segoe UI, Segoe, Tahoma, Helvetica, Arial, sans-serif";
            CurrStyle.fontSize = "13px";
            /* Center dialog vertically and horizontally */
            CurrStyle.display = "none";
            CurrStyle.alignItems = "center";
            CurrStyle.justifyContent = "center";
            this.DialogContent = new kDiv().Div;
            this.DialogContent.classList.add("kDialogContent");
            if(this.DialogContent===null){return;}
            this.DialogContent.setAttribute("role", "dialog");
            this.DialogContent.setAttribute("aria-modal", "true");
            this.DialogContent.style.position = "relative";
            this.DialogContent.style.display = "flex";
            this.DialogContent.style.flexDirection = "column";
            this.DialogContent.style.overflow = "hidden";
            CurrStyle = this.DialogContent.style;
            CurrStyle.backgroundColor = "#fefefe";
            CurrStyle.margin = "0";
            CurrStyle.padding = "16px";
            CurrStyle.border = "1px solid #d2d0ce";
            CurrStyle.borderRadius = "8px";
            CurrStyle.boxShadow = "0 8px 32px rgba(0,0,0,0.18)";

            this.CancelButtonTopRight = document.createElement("span");
            this.CancelButtonTopRight.className = "kDialogTopRightClose";
            this.CancelButtonTopRight.textContent = "×";
            this.CancelButtonTopRight.setAttribute("role", "button");
            this.CancelButtonTopRight.setAttribute("aria-label", "Close dialog");
            this.CancelButtonTopRight.setAttribute("tabindex", "0");
            const kCloseStyle:kStyleClass = kStyles.AddStyle("kDialogTopRightClose");
            if(kCloseStyle.Saved === false){
                CurrStyle = kCloseStyle.Style;
                CurrStyle.position = "absolute";
                CurrStyle.top = "8px";
                CurrStyle.right = "12px";
                CurrStyle.cursor = "pointer";
                CurrStyle.display = "flex";
                CurrStyle.alignItems = "center";
                CurrStyle.justifyContent = "center";
                CurrStyle.width = "24px";
                CurrStyle.height = "24px";
                CurrStyle.borderRadius = "4px";
                CurrStyle.color = "white";
                CurrStyle.fontSize = "18px";
                CurrStyle.lineHeight = "1";
            }
            kCloseStyle.Apply(this.CancelButtonTopRight);

            this.CancelButtonTopRight.addEventListener("click", this.Close);
            this.DialogContent.appendChild(this.CancelButtonTopRight);

            this.TitleDiv = new kDiv("kDialogTitle").Div;
            this.TitleDiv.style.minHeight = "18px";
            const TitleId: string = "kDlgTitle_" + Date.now() + "_" + Math.floor(Math.random() * 10000);
            this.TitleDiv.id = TitleId;
            this.DialogContent.setAttribute("aria-labelledby", TitleId);
            if(this.TitleDiv !== null){
                this.DialogContent.appendChild(this.TitleDiv);
            }

            this.InnerContent = new kDiv("kDialogInnerContent").Div;
            if(this.InnerContent){
                this.InnerContent.style.flex = "1";
                this.InnerContent.style.minHeight = "0";
                this.InnerContent.style.width = "100%";
                this.DialogContent.appendChild(this.InnerContent);
            }
            if (this.showCancelButton || this.showOKButton) {
                if (OKButtonFirst) {
                    if (this.showOKButton) {
                        this.AddOKButton();
                    }
                    if (this.showCancelButton) {
                        this.AddCancelButton();
                    }
                } else {
                    if (this.showCancelButton) {
                        this.AddCancelButton();
                    }
                    if (this.showOKButton) {
                        this.AddOKButton();
                    }
                }
            }
            this.DialogContainer.appendChild(this.DialogContent);
            this._AttemptAddContainer();

        } catch (e) { ks.kGlobalErrorHandler(e, "kModalDialog.contructor"); }    
    }
    private _AttemptAddContainer = (): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            document.body.appendChild(this.DialogContainer);
        } catch (e) { 
            window.setTimeout(this._AttemptAddContainer,200);
        }    
    }
    public Show = (): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            if(this.DialogContent &&  this.DialogContainer && this.InnerContent){
                if(this.isOpen === false){
                    this._PreviouslyFocused = document.activeElement as HTMLElement || null;
                    if(this.TitleDiv){
                        this.TitleDiv.textContent = this.Title;
                    }
                    this.DialogContent.setAttribute("aria-label", this.Title || "Dialog");
                    this.SetWidth();
                    this.SetHeigth();
                    if(this.Top >-1){
                        this.DialogContent.style.marginTop = this.Top +"px";
                    }
                    if (this.showOKButton) {
                        this.AddOKButton();
                    }
                    if (this.showCancelButton) {
                        this.AddCancelButton();
                    }
                    this.DialogContainer.style.display = "flex";
                    this.isOpen = true;
                    this._SetupFocusTrap();
                    this._FocusFirstElement();
                    this._KeyHandler = (ev: KeyboardEvent): void => {
                        try {
                            if (ev.key === "Escape") {
                                ev.stopPropagation();
                                if (this.OnCancelCB) {
                                    ks.DoCallBack(this.OnCancelCB, false);
                                }
                                this.Close();
                            } else if (ev.key === "Enter" && this.OKCB) {
                                const Tag: string = ev.target ? (ev.target as HTMLElement).tagName || "" : "";
                                if (Tag !== "TEXTAREA" && Tag !== "SELECT" && Tag !== "INPUT") {
                                    ev.stopPropagation();
                                    ks.DoCallBack(this.OKCB, true);
                                    this.Close();
                                }
                            }
                        } catch (e) { ks.kGlobalErrorHandler(e, "kModalDialog._KeyHandler"); }
                    };
                    document.addEventListener("keydown", this._KeyHandler);
                }else{
                    console.log("Trying to hide dialog that was already closed!");
                }
            }
        } catch (e) { ks.kGlobalErrorHandler(e, "this.Show"); }
    }
    private _GetButtonRow = (): HTMLDivElement => {
        if (this._ButtonRow) { return this._ButtonRow; }
        this._ButtonRow = document.createElement("div");
        this._ButtonRow.style.display = "flex";
        this._ButtonRow.style.justifyContent = "flex-end";
        this._ButtonRow.style.gap = "8px";
        this._ButtonRow.style.marginTop = "12px";
        this.DialogContent.appendChild(this._ButtonRow);
        return this._ButtonRow;
    }
    public AddCancelButton = (Callback?: any): void => {
        if (ks.kErrorMode === true && ks.kShowingErrorDialog ===false) { return; }
        try {
            this.CancelButton = new khtmlButton("kDialogCancelButton");
            if (this.CancelButton.Button) {
                const Row: HTMLDivElement = this._GetButtonRow();
                Row.appendChild(this.CancelButton.Button);
                this.OnCancelCB = Callback;
                if (this.CancelButtonCaption) {
                    this.CancelButton.SetText(this.CancelButtonCaption);
                } else {
                    this.CancelButton.SetText(LNG.CANCEL);
                }
                this.CancelButton.SetCallBack(this._CancelClick);
            }
        } catch (e) { ks.kGlobalErrorHandler(e, "kModalDialog.AddCancelButton"); }
    }
    private _CancelClick = (): void => {
        if (ks.kErrorMode === true && ks.kShowingErrorDialog ===false) { return; }
        try {
            if (this.OnCancelCB) {
                ks.DoCallBack(this.OnCancelCB, false);
            }
            this.Close();
        } catch (e) { ks.kGlobalErrorHandler(e, "kModalDialog._CancelClick"); }    
    }
    public AddOKButton = (Callback?: any): void => {
        if (ks.kErrorMode === true && ks.kShowingErrorDialog ===false) { return; }
        try {
            this.OKButton = new khtmlButton("kDialogOKButton");
            if (this.OKButton.Button) {
                this.OKButton.Button.style.borderWidth = "2px";
                const Row: HTMLDivElement = this._GetButtonRow();
                Row.appendChild(this.OKButton.Button);
                if (Callback) {
                    this.OKCB = Callback;
                }
                if (ks.nz(this.OKButtonCaption) !== "") {
                    this.OKButton.SetText(this.OKButtonCaption);
                } else {
                    this.OKButton.SetText(LNG.OK);
                }
                this.OKButton.SetCallBack(this._OKClick);
            }
        } catch (e) { ks.kGlobalErrorHandler(e, "kModalDialog.AddOKButton"); }
    }
    private _OKClick = (): void => {
        if (ks.kErrorMode === true && ks.kShowingErrorDialog ===false) { return; }
        try {
            if (this.OKCB) {
                ks.DoCallBack(this.OKCB,true);
            }
            this.Close();
        } catch (e) { ks.kGlobalErrorHandler(e, "kModalDialog._OKClick"); }    
    }
    public SetTitle = (NewTitle:string): void => {
        if (ks.kErrorMode === true && ks.kShowingErrorDialog ===false) { return; }
        try {
            this.TitleDiv.textContent = NewTitle;
            this.Title = NewTitle;
            if (this.DialogContent) {
                this.DialogContent.setAttribute("aria-label", NewTitle || "Dialog");
            }
        } catch (e) { ks.kGlobalErrorHandler(e, "kModalDialog.SetTitle"); }
    }
    public SetStandardAppTitle = (): void => {
        if (ks.kErrorMode === true && ks.kShowingErrorDialog ===false) { return; }
        try {
            this.SetTitle(ks.kApplication.name + " " + ks.kApplication.version);
            this.SetGreyTitle();
        } catch (e) { ks.kGlobalErrorHandler(e, "kModalDialog.SetStandardAppTitle"); }    
    }
    public CancelDialog = (): void => {
        if (ks.kErrorMode === true && ks.kShowingErrorDialog ===false) { return; }
        try {
            this.Close();
            if (this.OnCancelCB){
                ks.DoCallBack(this.OnCancelCB, null, false);
            }
        } catch (e) { ks.kGlobalErrorHandler(e, "kModalDialog.CancelDialog"); }    
    }
    public SetGreyTitle = (): void => {
        if (ks.kErrorMode === true && ks.kShowingErrorDialog ===false) { return; }
        try {
            const TitleStyle: CSSStyleDeclaration = this.TitleDiv.style;
            TitleStyle.backgroundColor = "#06b5ea";
            TitleStyle.marginLeft = "-16px";
            TitleStyle.marginRight= "-16px";
            TitleStyle.marginTop = "-16px";
            TitleStyle.color = "white";
            TitleStyle.borderRadius = "8px 8px 0 0";

            TitleStyle.minHeight = "28px";
            TitleStyle.paddingTop = "7px";
            TitleStyle.paddingLeft = "12px";
            TitleStyle.paddingBottom = "7px";
            TitleStyle.marginBottom = "12px";

            
        } catch (e) { ks.kGlobalErrorHandler(e, "kModalDialog.SetGreyTitle"); }    
    }
    public Close = (): void => {
        if (ks.kErrorMode === true && ks.kShowingErrorDialog ===false) { return; }
        try {
            if (this.DialogContent && this.DialogContainer){
                this.DialogContainer.style.display = "none";
                if(this.DestroyOnClose === true){
                    this.DialogContent.innerHTML = "";
                    this.DialogContent.remove();
                    this.DialogContainer.innerHTML = "";
                    this.DialogContainer.remove();
                }
            }
            this.isOpen = false;
            if (this._KeyHandler) {
                document.removeEventListener("keydown", this._KeyHandler);
                this._KeyHandler = null;
            }
            if (this._FocusTrapHandler) {
                this.DialogContent.removeEventListener("keydown", this._FocusTrapHandler);
                this._FocusTrapHandler = null;
            }
            if (this._PreviouslyFocused) {
                try { this._PreviouslyFocused.focus(); } catch (_e) { /* element may be gone */ }
                this._PreviouslyFocused = null;
            }
        } catch (e) { ks.kGlobalErrorHandler(e, "kModalDialog.Close"); }
    }
    private _FocusFirstElement = (): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            const Focusable: NodeListOf<HTMLElement> = this.DialogContent.querySelectorAll(
                "button, [href], input, select, textarea, [tabindex]:not([tabindex=\"-1\"])"
            );
            if (Focusable.length > 0) {
                Focusable[0].focus();
            } else {
                this.DialogContent.focus();
            }
        } catch (e) { ks.kGlobalErrorHandler(e, "kModalDialog._FocusFirstElement"); }
    }
    private _SetupFocusTrap = (): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            this._FocusTrapHandler = (ev: KeyboardEvent): void => {
                try {
                    if (ev.key !== "Tab") { return; }
                    const Focusable: NodeListOf<HTMLElement> = this.DialogContent.querySelectorAll(
                        "button, [href], input, select, textarea, [tabindex]:not([tabindex=\"-1\"])"
                    );
                    if (Focusable.length === 0) { return; }
                    const First: HTMLElement = Focusable[0];
                    const Last: HTMLElement = Focusable[Focusable.length - 1];
                    if (ev.shiftKey) {
                        if (document.activeElement === First) {
                            ev.preventDefault();
                            Last.focus();
                        }
                    } else {
                        if (document.activeElement === Last) {
                            ev.preventDefault();
                            First.focus();
                        }
                    }
                } catch (e) { ks.kGlobalErrorHandler(e, "kModalDialog._FocusTrapHandler"); }
            };
            this.DialogContent.addEventListener("keydown", this._FocusTrapHandler);
        } catch (e) { ks.kGlobalErrorHandler(e, "kModalDialog._SetupFocusTrap"); }
    }
    public AddContent = (NewElem:HTMLElement ): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            this.InnerContent.appendChild(NewElem);
        } catch (e) { ks.kGlobalErrorHandler(e, "kModalDialog.AddContent"); }
    }
    public SetWidth = (): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            if(this.DialogContent && this.DialogContainer){
                if(this.Width === 0){
                    this.DialogContent.style.width ="80%"; /* Could be more or less, depending on screen size */
                }else{
                
                    this.DialogContent.style.width = this.Width.toString() + "px";
                }
            }
        } catch (e) { ks.kGlobalErrorHandler(e, "kModalDialog.SetWidth"); }    
    }

    public SetHeigth = (): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            if(this.Height === 0){
                this.DialogContent.style.height ="80%"; /* Could be more or less, depending on screen size */
            }else{
                this.DialogContent.style.height = this.Height.toString() + "px";
            }
        } catch (e) { ks.kGlobalErrorHandler(e, "kModalDialog.SetWidth"); }    
    }
    public SetContent = (NewHTML:string): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            this.InnerContent.innerHTML = NewHTML;
            this.ContentHTML = NewHTML;
        } catch (e) { ks.kGlobalErrorHandler(e, "kModalDialog.SetContent"); }    
    }
    public SetContentElement = (NewContent:Element): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            this.InnerContent.innerHTML = "";
            this.InnerContent.appendChild(NewContent);
        } catch (e) { ks.kGlobalErrorHandler(e, "kModalDialog.SetContentElement"); }    
    }
    public SetCancelButton = (): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            if(this.showCancelButton){
                if("" !== this.CancelButtonCaption){
                    this.CancelButton.SetText(this.CancelButtonCaption);
                }else{
                    this.CancelButton.SetText(LNG.CANCEL);
                }
                if(this.OnCancelCB){
                    this.CancelButton.SetCallBack(this.OnCancelCB);
                }else{
                    this.CancelButton.SetCallBack(this.Close);
                }
            }else{
                this.CancelButton.Button.style.display = "none";
            }
        } catch (e) { ks.kGlobalErrorHandler(e, "kModalDialog.SetCancelButton"); }    
    }
}
